import getters from './getters'
import actions from './actions'
import mutations from './mutations'

export default {
  namespaced: true,
  state() {
    return {
      collapsed: localStorage.getItem('collapsed') || false,
      menu: [
        {
          icon: 'gauge-max',
          pageName: 'dashboard_main_page_route',
          title: 'template_dashboard_title_main'
        },
        {
          icon: 'folder',
          pageName: 'dashboard_dossier_main_page_route',
          title: 'dossier_title',
          gate: 'see_dossier',
          meta: {
            breadcrumb: [
              { title: 'Content', active: false },
              { title: 'Company', active: true }
            ]
          }
        },
        {
          icon: 'calendar-days',
          pageName: 'agenda_page_route',
          title: 'agenda_title',
          gate: 'see_planning'
        },
        {
          icon: 'calendar-circle-user',
          pageName: 'planning_page_route',
          title: 'planning_title',
          gate: 'see_planning'
        },
        {
          icon: 'mailbox',
          pageName: 'mail_box_page',
          title: 'messaging_title',
          gate: ['see_content', 'manage_dossier', 'manage_invoicing']
        },
        {
          icon: 'address-book',
          pageName: 'address_book_page_route',
          title: 'address_book_title_main',
          // The API gates the whole directory behind see_address_book
          // (routes/Models/ContactDirectory.php), so see_content both showed
          // this entry to users the API answers with a 403 and hid it from some
          // who are entitled to it.
          gate: 'see_address_book'
        },
        {
          icon: 'location-dot',
          pageName: 'wiki_city_page_route',
          title: 'wiki_commune_title_main'
        },
        {
          icon: 'square-check',
          pageName: 'task_page_route',
          title: 'tasks_title_main',
          gate: 'manage_dossier'
        },
        {
          icon: 'square-check',
          pageName: 'tasks_index_route',
          title: 'tasks_title_main',
          gate: false
        },
        {
          icon: 'euro-sign',
          pageName: 'invoicing_root_page',
          title: 'invoicing_title_main',
          gate: 'see_invoicing',
          meta: { open_for_customer: true }
        },
        {
          icon: 'file-signature',
          pageName: 'electronic_signature_root_route',
          title: 'electronic_signature_title_main',
          functionality: 'electronic_signature'
        },
        {
          icon: 'truck',
          pageName: 'supplier_order_page_route',
          title: 'supplier_order_title_main',
          gate: 'see_invoicing'
        },
        {
          icon: 'file-export',
          pageName: 'export_page_route',
          title: 'export_title_main',
          gate: 'generate_export'
        },
        {
          icon: 'calendar-clock',
          pageName: 'scheduled_task_list_route',
          title: 'scheduled_tasks_title_main',
          gate: 'manage_scheduled_tasks'
        },
        {
          icon: 'analytics',
          pageName: 'dashboard_analytics_route',
          title: 'statistics_title',
          gate: 'see_statistics'
        },
        {
          icon: 'boxes-stacked',
          pageName: 'stock_page_route',
          title: 'stock_title',
          gate: 'manage_stock'
        },
        {
          icon: 'feather',
          pageName: 'condolence_page_route',
          title: 'condolences_title',
          gate: 'see_content'
        },
        {
          icon: 'store',
          pageName: 'marketplace_list',
          title: 'marketplace_title_main',
          gate: 'see_marketplace'
        },
        {
          icon: 'font-awesome',
          pageName: 'activity_log_route',
          title: 'activity_log_title_main',
          gate: 'see_activities'
        },
        {
          icon: 'cogs',
          pageName: 'settings_list_user_route',
          title: 'settings',
          gate: 'see_content'
        },
        {
          icon: 'gauge-circle-bolt',
          pageName: 'management_general_route',
          title: 'sa_management',
          gate: 'super-admin'
        }
      ]
    }
  },
  mutations,
  actions,
  getters
}
